<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :showGroupActions="showGroupActions" />
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ListMixin from '@/mixins/list'
import WindowsMixin from '@/mixins/windows'
import { getNameFilter } from '@/utils/common/tableFilter'
import { getTimeTableColumn } from '@/utils/common/tableColumn'

export default {
  name: 'discountInfoList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    showGroupActions: {
      type: Boolean,
      default: () => true,
    },
  },
  data () {
    return {
      loading: false,
      list: this.$list.createList(this, {
        id: 'discountInfoList',
        resource: 'rates',
        apiVersion: 'v1',
        getParams: {
          is_available: true,
          filter: [
            `cloudaccount_id.equals(${this.data.cloudaccount_id || this.data.id})`, // ${this.data.cloudaccount_id}
          ],
        },
        filterOptions: {
          name: getNameFilter(),
        },
      }),
      columns: [
        {
          field: 'resource_type',
          title: this.$t('scope.text_537'),
          // formatter: ({ cellValue }) => {
          //   if (cellValue === '') {
          //     return '全部'
          //   }
          //   const val = cellValue.toUpperCase()
          //   return val
          // },
          slots: {
            default: ({ row }, h) => {
              let name = ''
              if (row.resource_type === '') {
                name = this.$t('scope.text_515')
              } else {
                name = row.resource_type.toUpperCase()
              }
              const ret = [
                <list-body-cell-wrap row={row} list={this.list} hideField={ true }>
                  <side-page-trigger onTrigger={ () => this.handleOpenSidepage(row) }>{ name }</side-page-trigger>
                </list-body-cell-wrap>,
              ]
              return ret
            },
          },
        },
        {
          field: 'model',
          title: this.$t('common_616'),
          formatter: ({ row, cellValue }) => {
            if (!cellValue) {
              return '-'
            }
            return cellValue
          },
        },
        {
          field: 'price',
          title: this.$t('scope.text_538'),
          formatter: ({ row, cellValue }) => {
            if (row.price_type === 'percent') {
              return cellValue * 100 + '%'
            } else {
              return cellValue + (row.unit || '')
            }
          },
        },
        getTimeTableColumn({ field: 'enable_time', title: this.$t('scope.text_511') }),
        {
          field: 'remark',
          title: this.$t('scope.text_512'),
        },
      ],
      groupActions: [
        {
          label: this.$t('scope.text_539'),
          action: () => {
            this.createDialog('CreateDiscountDialog', {
              title: this.$t('scope.text_540'),
              onManager: this.onManager,
              refresh: this.refresh,
              cloudaccountId: this.data.cloudaccount_id,
              domain_id: this.data.domain_id,
              brand: this.data.provider,
            })
          },
          meta: () => ({ buttonType: 'primary' }),
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['scope']),
    ...mapState('app', {
      customer: state => state.customer,
    }),
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'HistoricalRateSidePage', {
        id: row.id,
        resource: 'rates',
        apiVersion: 'v1',
        getParams: {
          scope: this.scope,
          show_fail_reason: true,
          limit: 20,
          filter: [
            `domain_id.equals(${this.data.domain_id})`,
            `cloudaccount_id.equals(${this.data.cloudaccount_id})`,
          ],
        },
        tab: '',
      }, {
        list: this.list,
      })
    },
  },
}
</script>
